import { RoomOwnerId } from "../interface";
import { AnyAccountJwtVO, Conf2AccountJwtVO } from "../vo";
import { AnyAccountJwtVOSpecs } from "./any-account-jwt-vo.specs";
import { Conf2AccountSpecs } from "./conf2";

export class HostSpecs {
  static isHost(
    accountJwt: undefined | null | AnyAccountJwtVO,
    // TODO: roomOwnerId shouldn't be optional
    roomOwnerId?: null | RoomOwnerId
  ) {
    if (AnyAccountJwtVOSpecs.isIdentityAccountJwtVO(accountJwt)) {
      // TODO: check roomOwnerId
      return roomOwnerId ? accountJwt.value.id === roomOwnerId : true;
    }

    if (accountJwt instanceof Conf2AccountJwtVO) {
      // 'Conf2 Host' is minted for a room of the 'Conf2 Customer' (accountId),
      // it's not a host of the other customers rooms. Bound to its LiveE
      // session's room (conf2ChatSessionId, YOUM-267): the room itself is
      // checked where it is resolved (Conf2RoomBindingAdapter)
      return (
        Conf2AccountSpecs.isHost(accountJwt.value.type) &&
        (roomOwnerId ? accountJwt.value.accountId === roomOwnerId : true)
      );
    }

    return false;
  }
}
